import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../common/EditPage';
import { create, getOne } from './../../../common/v4/BackendProvider';
import SelectContainer from './../../../common/SelectContainer';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const TTSVoiceCreate = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({
        name: '',
        description: '',
        gender: 'neutral',
        provider: '',
        provider_id: '',
        speed: 1.0,
        enabled: true
    });
    const [metadata, setMetadata] = useState({
        genders: [],
        providers: []
    });
    const [sampleFile, setSampleFile] = useState(null);

    useEffect(() => {
        getOne('/admin/settings/tts-voices/new', '').then(response => {
            if (response.data.result === 'OK') {
                setMetadata(response.data.data);
            }
        });
    }, []);
    
    const handleSave = () => {
        const formData = new FormData();
        // Always append all required fields
        formData.append('name', String(data.name || ''));
        formData.append('description', String(data.description || ''));
        formData.append('gender', String(data.gender || 'neutral'));
        formData.append('provider', String(data.provider || ''));
        formData.append('provider_id', String(data.provider_id || ''));
        formData.append('speed', String(data.speed || 1.0));
        // Laravel boolean validation accepts: true, false, 1, 0, "1", "0", "true", "false", "on", "off", "yes", "no"
        formData.append('enabled', data.enabled === true || data.enabled === 1 || data.enabled === '1' || data.enabled === 'true' ? '1' : '0');
        if (data.client_id) {
            formData.append('client_id', String(data.client_id));
        }
        if (sampleFile) {
            formData.append('sample', sampleFile);
        }
        
        create('/admin/settings/tts-voices', {data: formData}).then(response => {
            toast.success("TTS Voice created successfully", {});
            navigate('/settings/tts_voices');
        }).catch(error => {
            const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
            toast.error("Error creating TTS Voice: " + errorMessage, {});
        });
    }

    const handleCancel = () => {
        navigate('/settings/tts_voices');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validate file type
            const allowedTypes = ['audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/mp4', 'audio/x-m4a'];
            const allowedExtensions = ['.mp3', '.wav', '.ogg', '.m4a'];
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
            
            if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
                toast.error('Invalid file type. Please upload mp3, wav, ogg, or m4a files only.', {});
                return;
            }
            
            // Validate file size (10MB max)
            if (file.size > 10 * 1024 * 1024) {
                toast.error('File size exceeds 10MB limit.', {});
                return;
            }
            
            setSampleFile(file);
        }
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create TTS Voice" >
                <EditPagePanel>
                    <EditPageTextField label="Name" id="name" onChange={ onChange } value={ data.name } />
                    <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                    <SelectContainer 
                        label="Gender" 
                        id="gender" 
                        onChange={ onChange } 
                        value={ data.gender }
                        options={metadata.genders}
                    />
                    <SelectContainer 
                        label="Provider" 
                        id="provider" 
                        onChange={ onChange } 
                        value={ data.provider }
                        options={metadata.providers}
                    />
                    <EditPageTextField label="Provider ID" id="provider_id" onChange={ onChange } value={ data.provider_id } />
                    <EditPageTextField 
                        label="Speed" 
                        id="speed" 
                        onChange={ onChange } 
                        value={ data.speed }
                        type="number"
                        step="0.01"
                        min="0.1"
                        max="3.0"
                    />
                    <EditPageCheckbox label="Enabled" id="enabled" onChange={ onChange } value={ data.enabled } />
                    <div className="form-group" style={{ marginBottom: '1rem' }}>
                        <label htmlFor="sample" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                            Voice Sample (Optional)
                        </label>
                        <input
                            type="file"
                            id="sample"
                            accept=".mp3,.wav,.ogg,.m4a,audio/mpeg,audio/wav,audio/ogg,audio/mp4"
                            onChange={handleFileChange}
                            style={{ display: 'block', width: '100%', padding: '0.375rem 0.75rem' }}
                        />
                        <small className="form-text text-muted">
                            Upload an audio sample to preview the voice. Accepted formats: MP3, WAV, OGG, M4A (max 10MB)
                        </small>
                        {sampleFile && (
                            <div style={{ marginTop: '0.5rem', padding: '0.5rem', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                                <strong>Selected:</strong> {sampleFile.name} ({(sampleFile.size / 1024 / 1024).toFixed(2)} MB)
                            </div>
                        )}
                    </div>
                </EditPagePanel>
            </EditPage>
        </div>
    )
}

export default TTSVoiceCreate;
